import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import CTASection from './CTASection';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <>
      <CTASection />
      
      <footer className="footer">
        <div className="footer-content">
          {/* Company Description Section */}
          <div className="footer-section footer-brand">
            <h3>reventlabs.</h3>
            <p className="footer-description">
              Bring on your technology challenges. At ReventLabs, we believe that complex infrastructure problems are opportunities for innovation.
            </p>
          </div>

          {/* Navigation Section */}
          <div className="footer-section">
            <h3>reventlabs.</h3>
            <ul>
              <li><Link to="/why-us">Why Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/industries">Industries</Link></li>
              <li><Link to="/security">Security</Link></li>
            </ul>
          </div>

          {/* Services Section */}
          <div className="footer-section">
            <h3>Services</h3>
            <ul>
              <li><Link to="/services/cloud-cost-optimization" onClick={scrollToTop}>Cloud Cost Optimization</Link></li>
              <li><Link to="/services/kubernetes-consulting" onClick={scrollToTop}>Kubernetes Consulting</Link></li>
              <li><Link to="/services/ai-genai-integration" onClick={scrollToTop}>AI & GenAI Integration</Link></li>
              <li><Link to="/services/mlops-platform-engineering" onClick={scrollToTop}>MLOps & ML Platform</Link></li>
              <li><Link to="/services/terraform-pulumi" onClick={scrollToTop}>Terraform & Pulumi</Link></li>
              <li><Link to="/services/sre-consulting" onClick={scrollToTop}>SRE Consulting</Link></li>
              <li><Link to="/services/prometheus-grafana" onClick={scrollToTop}>Prometheus & Grafana</Link></li>
            </ul>
          </div>

          {/* Industries Section */}
          <div className="footer-section">
            <h3>Industries</h3>
            <ul>
              <li><Link to="/industries/finance-banking" onClick={scrollToTop}>FinTech & BFSI</Link></li>
              <li><Link to="/industries/government-public-sector" onClick={scrollToTop}>Government & Public Sector</Link></li>
              <li><Link to="/industries/healthcare-life-sciences" onClick={scrollToTop}>Healthcare</Link></li>
              <li><Link to="/industries/retail-ecommerce" onClick={scrollToTop}>E-commerce & Retail</Link></li>
              <li><Link to="/industries/manufacturing-industry-4" onClick={scrollToTop}>Manufacturing Industry 4.0</Link></li>
            </ul>
          </div>

          {/* Connect Section */}
          <div className="footer-section">
            <h3>Connect</h3>
            <ul>
              <li><a href="https://www.linkedin.com/company/reventlabs/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
              <li><a href="https://www.youtube.com/@reventlabs" target="_blank" rel="noopener noreferrer">YouTube</a></li>
              <li><a href="https://www.instagram.com/reventlabs/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
        </div>
      </footer>

      {/* Separate footer bottom section with black background */}
      <div className="footer-bottom">
        <div className='footer-bottom-container'>
          <div className="copyright">
            © {new Date().getFullYear()} reventlabs.
          </div>
          <div className="footer-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer; 